<template>
  <v-layout>
    <input
      id="trackUrl"
      style="position: absolute; left: -1000px; top: -1000px"
    >
    <v-flex
      md12
      lg12
      xl12
    >
      <v-menu bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="!simplified"
            small
            color="blue"
            class="text-none"
            dark
            v-on="on"
          >
            Message Customer
          </v-btn>
          <v-btn
            v-else
            x-small
            text
            color="blue"
            class="text-none"
            dark
            @click="morePressed"
            v-on="on"
          >
            More
          </v-btn>
        </template>

        <v-list
          v-if="bookingForm != null"
          dense
          style="width: 256px"
        >
          <v-list-item
            v-if="bookingForm.booking.state == 'cancelled'"
            class="text-none"
            small
            color="white"
            @click="recover"
          >
            Recover
          </v-list-item>
          <v-list-item
            class="text-none"
            small
            color="white"
            @click="copyPayLink"
          >
            Copy Pay Link
          </v-list-item>
          <v-list-item
            class="text-none"
            small
            color="white"
            @click="copyTrackLink"
          >
            Copy Track Link
          </v-list-item>
          <v-list-item
            class="text-none"
            small
            color="white"
            @click="showSendTrackLinkDialog"
          >
            Send Track Link (SMS)
          </v-list-item>
          <v-list-item
            class="text-none"
            small
            color="white"
            @click="showSendSMSDialog"
          >
            Send Message (SMS)
          </v-list-item>
          <v-list-item
            class="text-none"
            small
            color="white"
            @click="showSendCustomerConfirmationDialog"
          >
            Send Customer Confirmation Email
          </v-list-item>
          <v-list-item
              v-if="bookingForm.booking.state == 'completed'"
              class="text-none"
            small
            color="white"
            @click="showSendCustomerConfirmationDialog('review')"
          >
            Send Customer Review Email
          </v-list-item>
        </v-list>
        <div
          v-else
          style="height: 48px; width: 256px; background-color: white;"
        >
          <div style="padding-left: 9px; padding-top: 9px;">
            <v-progress-circular
              indeterminate
              color="primary"
              :size="30"
            />
          </div>
        </div>
      </v-menu>
    </v-flex>
    <v-flex
      md12
      lg12
      xl12
    >
      <v-flex
        v-if="!simplified"
        px-1
      />
      <v-dialog
        v-model="trackDialog"
        width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Send Track Link (SMS)</span>
          </v-card-title>
          <v-layout
            column
            px-4
          >
            <v-text-field
              v-model="smsContactNumber"
              label="Contact Number"
            />
            <p
              v-if="smsError != null"
              style="color:red;"
            >
              {{ smsError }}
            </p>
          </v-layout>
          <v-card-actions v-if="loadingSendSMS == false">
            <v-spacer />
            <v-btn
              class="text-none"
              text
              @click="trackDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="text-none"
              text
              @click="sendTrackURLMessage()"
            >
              Send Message
            </v-btn>
          </v-card-actions>
          <v-progress-linear
            v-if="loadingSendSMS == true"
            indeterminate
            color="yellow darken-2"
          />
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="customSMSDialog"
        width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Send Custom SMS</span>
          </v-card-title>
          <v-layout
            column
            px-4
          >
            <v-textarea
              v-model="customMessage"
              placeholder="Your custom message"
            />
            <v-text-field
              v-model="smsContactNumber"
              label="Contact Number"
            />
            <p
              v-if="smsError != null"
              style="color:red;"
            >
              {{ smsError }}
            </p>
          </v-layout>
          <v-card-actions v-if="loadingSendSMS == false">
            <v-spacer />
            <v-btn
              class="text-none"
              text
              @click="customSMSDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="text-none"
              text
              @click="sendCustomSMS()"
            >
              Send Message
            </v-btn>
          </v-card-actions>
          <v-progress-linear
            v-if="loadingSendSMS == true"
            indeterminate
            color="yellow darken-2"
          />
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="supplierConfirmationDialog"
        width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Send Supplier Confirmation</span>
          </v-card-title>
            <v-col
                cols="12"
                class="py-2 text-center"
            >
                <v-btn-toggle
                    v-if="bookingForm.booking.booking_type == 'repeat'"
                    v-model="emailType"
                    tile
                    color="deep-purple accent-3"
                    group
                >
                    <v-btn small  value="BookingConfirmation">
                        Booking Confirmation
                    </v-btn>
                    
                    <v-btn small value="RepeatServiceConfirmation">
                        Repeat Service Confirmation
                    </v-btn>
                    
                </v-btn-toggle>
            </v-col>
            
            <v-layout
            column
            px-4
          >
            <v-text-field
              v-model="email"
              label="Email"
            />
            <v-text-field
              v-model="extraText"
              label="Extra Text"
            />
            <v-btn @click="copyCovidPrompt">
              Copy COVID Prompt
            </v-btn>
            <p
              v-if="smsError != null"
              style="color:red;"
            >
              {{ smsError }}
            </p>
          </v-layout>
          <v-card-actions v-if="loadingSendSMS == false">
            <v-spacer />
            <v-btn
              class="text-none"
              text
              @click="supplierConfirmationDialogClosed"
            >
              Cancel
            </v-btn>
            <v-btn
              class="text-none"
              text
              @click="sendSupplierConfirmationEmail()"
            >
              Send Email
            </v-btn>
          </v-card-actions>
          <v-progress-linear
            v-if="loadingSendSMS == true"
            indeterminate
            color="yellow darken-2"
          />
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="customerConfirmationDialog"
        width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">{{confirmationEmailDialogTitle}}</span>
          </v-card-title>
          <v-layout
            column
            px-4
          >
            <v-text-field
              v-model="email"
              label="Email"
            />
            <p
              v-if="smsError != null"
              style="color:red;"
            >
              {{ smsError }}
            </p>
          </v-layout>
          <v-card-actions v-if="loadingSendSMS == false">
            <v-spacer />
            <v-btn
              class="text-none"
              text
              @click="customerConfirmationDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="text-none"
              text
              @click="sendConfirmationEmail()"
            >
              Send Email
            </v-btn>
          </v-card-actions>
          <v-progress-linear
            v-if="loadingSendSMS == true"
            indeterminate
            color="yellow darken-2"
          />
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="cancelDialog"
        persistent
        width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Cancel Booking</span>
          </v-card-title>
          <v-flex pa-4>
            <v-row>
              <v-flex
                v-if="bookingForm && bookingForm.booking.card_payment_type == 'prepaid'"
                shrink
              >
                <v-radio-group v-model="cancellationFee">
                  <v-radio
                    label="Use System Policy"
                    :value="0"
                  />
                  <v-radio
                    label="Yes, Charge Cancellation Fee"
                    :value="1"
                  />
                  <v-radio
                    label="No, Do NOT Charge Cancellation Fee"
                    :value="2"
                  />
                </v-radio-group>
              </v-flex>
              <v-flex
                shrink
                pl-5
              >
                <v-checkbox
                  v-if="bookingHasOtherTripToCancel"
                  v-model="cancelOtherTrip"
                  :label="'Cancel ' + nameForOtherTrip + ' trip'"
                />
              </v-flex>
            </v-row>
          </v-flex>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="cancelDialog = false"
            >
              Back
            </v-btn>
            <v-btn
              text
              @click="cancel"
            >
              Confirm Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleTextAreaInput from "@/components/widget/input/SimpleTextAreaInput.vue";

import BookTripETARoute from "@/components/widget/input/BookTripETARoute.vue";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "MessageCustomerMenu",
  components: {
    SimpleTextAreaInput,
    BookTripETARoute
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    showMessageSupplierDialog:{
      default: false,
      type: Boolean
    },
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    updateMode: {
      type: Boolean,
      default: false
    },
    largeMode: {
      type: Boolean,
      default: true
    },
    simplified: false,
  },
  data() {
    return {
      menu: false,
      cancelDialog: false,
      cancellationFee: false,
      cancelOtherTrip: false,
      trackDialog: false,
      customSMSDialog: false,
      loadingSendSMS: false,
      smsError: null,
      smsContactNumber: null,
      customMessage: "",
      supplierConfirmationDialog: false,
      customerConfirmationDialog: false,
      email: "",
      isReviewEmail: false,
       confirmationEmailDialogTitle: 'Send Confirmation Email',
      extraText: "",
      emailType: "BookingConfirmation"
    };
  },
  watch: {
    showMessageSupplierDialog() {
      if (this.showMessageSupplierDialog) {
        this.showSendSupplierConfirmationDialog()
      }
    }
  },
  computed: {
    nameForOtherTrip: function () {
      if (this.bookingForm) {
        if (
            this.bookingForm.booking.cart.outboundBookingId ==
            this.bookingForm.booking.id
        ) {
          return "Return";
        } else {
          return "Outbound";
        }
      }
    },
    bookingHasOtherTripToCancel: function () {
      if (this.bookingForm) {
        if (this.bookingForm.booking.cart == null) {
          return false;
        }

        if (
            this.bookingForm.booking.cart.outboundBookingId ==
            this.bookingForm.booking.id
        ) {
          if (this.bookingForm.booking.cart.returnBookingId != null) {
            if (
                this.bookingForm.booking.cart.returnState != "completed" &&
                this.bookingForm.booking.cart.returnState != "cancelled"
            ) {
              return true;
            }
          }
        } else {
          if (
              this.bookingForm.booking.cart.outboundState != "completed" &&
              this.bookingForm.booking.cart.outboundState != "cancelled"
          ) {
            return true;
          }
        }

        return false;
      }
    },
  },
    mounted () {
      if (this.bookingForm && this.bookingForm.booking && this.bookingForm.booking.preassigned_driver && this.bookingForm.booking.preassigned_driver_email) {
          this.email = this.bookingForm.booking.preassigned_driver_email
      }
    },
  methods: {
    supplierConfirmationDialogClosed() {
      this.supplierConfirmationDialog = false,
          this.$emit('supplierConfirmationDialogClose')
    },
    cancel: function () {
      this.cancelDialog = false;
      let params = {
        cancellationFee: this.cancellationFee,
        cancelOtherTrip: this.cancelOtherTrip,
      }

      this.$emit("cancel", {
        cancellationFee: this.cancellationFee,
        cancelOtherTrip: this.cancelOtherTrip,
      });
      this.bookingForm.cancelRide(this.cancelledBooking, params)
      // Promise.resolve(this.bookingForm.cancelRide(this.cancelledBooking(), params)).then(this.emitBookingCancelled())
    },
    emitBookingCancelled () {
      this.$emit('bookingCancelled', true)
    },
    cancelledBooking: function () {
      this.$emit("cancelledBooking", null);
    },
    recover: function(booking) {
      console.log("Recover called");

      var booking = this.bookingForm.booking;

      var url = `${this.$store.state.apiUrl}/booking/recover/${booking.id}?manual_dispatch=false`;

      var vm = this;
      
      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {

          if (res.data.error == "no_error") {
            console.log("Recovered trip");
            booking.state = 'booked';
            vm.$emit('reload')
          } else {
            alert("Failed to recover booking");
          }
        })
        .catch(function (err) {
          console.error(err);
        });
    },
    morePressed: function() {
      this.$emit("morePressed")
    },
    copyCovidPrompt: function() {
      this.extraText = "You will need to do a Lateral Flow test, 1 day prior to the journey and produce a negative test. Keep hold of the results as you may need to show this at the port.<br><br>You will also be required to retest at the port when dropping your passengers.Order test here: https://www.gov.uk/order-coronavirus-rapid-lateral-flow-tests<br><br>Please log on to the app 1 hr prior to your journey commencing.<br><br>Shirt, trousers and tie are a must. The vehicle must be immaculate internally and externally.<br><br>PORT PROCEDURES<br><br>Tag Collection<br><br>You must pick up your tag from Park and Ride Tipner Lane, PO2 8AN 15 minutes before your pick-up time. Location: https://goo.gl/maps/nhXg9G3v8C1htzd68<br><br>Once you have collected your tag, head down to Portsmouth International Port, George Byng Way, PO2 8SP.<br>https://goo.gl/maps/BY7q6zXNUCYceSWw7<br><br>You must get a lateral flow test with your customers at Park and Ride Tipner Lane, before you drop your customers at Portsmouth International Port"
    },
    copyTrackLink: function() {
      const el = document.getElementById("trackUrl");
      el.value = this.bookingForm.booking.track_booking_url;
      el.select();
      document.execCommand("copy");

      navigator.clipboard.writeText(this.bookingForm.booking.track_booking_url)

      console.log("Copied " + el.value);
    },
    openCopyBooking() {
      return window.open('book?rebook=' + this.bookingForm.booking.id)
    },
    openReturnBooking() {
      return window.open('book?rebook=' + this.bookingForm.booking.id + "&type=return")
    },
    copyPayLink: function() {
      const el = document.getElementById("trackUrl");
      el.value = this.bookingForm.booking.track_booking_url.replace("/track/", "/pay/");
      el.select();
      document.execCommand("copy");


      navigator.clipboard.writeText(this.bookingForm.booking.track_booking_url.replace("/track/", "/pay/"))

      console.log("Copied " + el.value);
    },
    showSendTrackLinkDialog: function() {
      this.smsError = null;

      if (this.bookingForm.booking.business_customer_number != null) {
        this.smsContactNumber = this.bookingForm.booking.business_customer_number;
      } else {
        this.smsContactNumber = this.bookingForm.user.contact_number;
      }

      this.trackDialog = true;
    },
    showSendCustomerConfirmationDialog: function(emailType) {
      this.smsError = null;

      if (emailType == 'review') {
          this.isReviewEmail = true
          this.confirmationEmailDialogTitle = 'Send Customer Review Email'
      } else {
          this.confirmationEmailDialogTitle = 'Send Customer Confirmation Email'
          this.isReviewEmail = false
      }
      if (this.bookingForm.booking.business_customer_email != null) {
        this.email = this.bookingForm.booking.business_customer_email;
      } else {
        this.email = this.bookingForm.user.email;
      }

      this.customerConfirmationDialog = true;
    },
    showSendSupplierConfirmationDialog: function() {
      this.smsError = null;

      if (this.bookingForm.booking.business_customer_email != null) {
        this.email = "";
      } else {
        this.email = "";
      }

      if (this.bookingForm.booking.preassigned_driver_email != null) {
        this.email = this.bookingForm.booking.preassigned_driver_email;
      }

      this.supplierConfirmationDialog = true;
    },
    showSendSMSDialog: function() {
      this.smsError = null;

      if (this.bookingForm.booking.business_customer_number != null) {
        this.smsContactNumber = this.bookingForm.booking.business_customer_number;
      } else {
        this.smsContactNumber = this.bookingForm.user.contact_number;
      }

      this.customSMSDialog = true;
    },
    sendTrackURLMessage: async function() {
      console.log("Sending Track URL");

      this.smsError = null;

      if (this.smsContactNumber == null || this.smsContactNumber.length <= 0) {
        this.smsError =
          "Please enter a contact number for the messages recipient";
        return;
      }

      this.loadingSendSMS = true;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/sendTrackURLMessage?booking_id=${
            this.bookingForm.booking.id
          }&contact_number=${this.smsContactNumber.trim()}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingSendSMS = false;

        if (response.data.error == "no_error") {
          this.trackDialog = false;
        } else {
          this.smsError = response.data.error;
        }
      } catch (error) {
        console.log(error);
        this.smsError = "Unknown Error";

        this.loadingSendSMS = false;
      }
    },
    sendCustomSMS: async function() {
      console.log("Sending Track URL");

      this.smsError = null;
      var booking = this.bookingForm.booking;
  
  
      if (this.smsContactNumber == null || this.smsContactNumber.length <= 0) {
        this.smsError =
          "Please enter a contact number for the messages recipient";
        return;
      }

      this.loadingSendSMS = true;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/customMessageBooking?message=${
            this.customMessage
          }&contact_number=${this.smsContactNumber.trim()}&booking_id=${booking.id}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingSendSMS = false;

        console.log(response.data.error);

        if (response.data.error == "no_error") {
          this.customSMSDialog = false;
        } else {
          this.smsError = response.data.error;
        }
      } catch (error) {
        console.log(error);
        this.smsError = "Unknown Error";

        this.loadingSendSMS = false;
      }
    },
    sendSupplierConfirmationEmail: async function() {
      console.log("Sending Supplier Confirmation Email");

      this.smsError = null;

      this.loadingSendSMS = true;
      let url = `${this.$store.state.apiUrl}/booking/sendSupplierConfirmation?booking_id=${
          this.bookingForm.booking.id
      }&email=${this.email.trim()}&extraText=${this.extraText}`
        
        if (this.emailType) {
            url += `&email_type=${this.emailType}`
        }

      try {
        let response = await axios.post(
            url
          ,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingSendSMS = false;

        console.log(response.data.error);

        if (response.data.error == "no_error") {
          this.supplierConfirmationDialog = false;
          this.$emit('supplierConfirmationDialogClose')

        } else {
          this.smsError = response.data.error;
        }
      } catch (error) {
        console.log(error);
        this.smsError = "Unknown Error";

        this.loadingSendSMS = false;
      }
    },
    sendConfirmationEmail: async function() {
      console.log("Sending Supplier Confirmation Email");

      this.smsError = null;

      this.loadingSendSMS = true;

      let url = `${this.$store.state.apiUrl}/booking/sendConfirmation?booking_id=${
          this.bookingForm.booking.id
      }&email=${this.email.trim()}`
        
        if (this.isReviewEmail) {
            url += `&review_email=${this.isReviewEmail}`
        }
      try {
        let response = await axios.post(url,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingSendSMS = false;

        console.log(response.data.error);

        if (response.data.error == "no_error") {
          this.customerConfirmationDialog = false;
        } else {
          this.smsError = response.data.error;
        }
      } catch (error) {
        console.log(error);
        this.smsError = "Unknown Error";

        this.loadingSendSMS = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
